module.exports = __webpack_public_path__ + "img/back.3f7e1a53.svg";